module.exports = __webpack_public_path__ + "img/bancos.26eba263.png";